import React from 'react';
import './AboutPage.css';

const AboutPage = () => {
  return (
    <div className="about">
      <div className="about-header">
        <h2>About AESOP PRICING</h2>
        <p>Your comprehensive pricing management solution</p>
      </div>

      <div className="about-content">
        {/* Mission Section */}
        <div className="about-section">
          <h3>Our Mission</h3>
          <p>
            AESOP PRICING is designed to revolutionize how businesses manage their pricing strategies. 
            We provide a comprehensive platform that enables companies to optimize their pricing, 
            track market trends, and maximize profitability through data-driven insights.
          </p>
        </div>

        {/* Features Section */}
        <div className="about-section">
          <h3>Key Features</h3>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h4>Advanced Analytics</h4>
              <p>Comprehensive pricing analytics and reporting tools</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🎯</div>
              <h4>Smart Pricing</h4>
              <p>AI-powered pricing recommendations and optimization</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📈</div>
              <h4>Market Tracking</h4>
              <p>Real-time market monitoring and competitor analysis</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🔄</div>
              <h4>Automation</h4>
              <p>Automated pricing updates and workflow management</p>
            </div>
          </div>
        </div>

        {/* Technology Stack */}
        <div className="about-section">
          <h3>Technology Stack</h3>
          <div className="tech-stack">
            <div className="tech-item">
              <span className="tech-label">Frontend:</span>
              <span className="tech-value">React.js, Redux Toolkit</span>
            </div>
            <div className="tech-item">
              <span className="tech-label">Styling:</span>
              <span className="tech-value">CSS3, Responsive Design</span>
            </div>
            <div className="tech-item">
              <span className="tech-label">Routing:</span>
              <span className="tech-value">React Router v6</span>
            </div>
            <div className="tech-item">
              <span className="tech-label">HTTP Client:</span>
              <span className="tech-value">Axios with Interceptors</span>
            </div>
            <div className="tech-item">
              <span className="tech-label">Authentication:</span>
              <span className="tech-value">JWT Token-based</span>
            </div>
          </div>
        </div>

        {/* Version Info */}
        <div className="about-section">
          <h3>Version Information</h3>
          <div className="version-info">
            <div className="version-item">
              <span className="version-label">Current Version:</span>
              <span className="version-value">1.0.0</span>
            </div>
            <div className="version-item">
              <span className="version-label">Release Date:</span>
              <span className="version-value">June 2024</span>
            </div>
            <div className="version-item">
              <span className="version-label">Build:</span>
              <span className="version-value">Production</span>
            </div>
          </div>
        </div>

        {/* Contact Information */}
        <div className="about-section">
          <h3>Contact & Support</h3>
          <div className="contact-info">
            <div className="contact-item">
              <span className="contact-icon">📧</span>
              <div>
                <h4>Email Support</h4>
                <p>support@aesoppricing.com</p>
              </div>
            </div>
            <div className="contact-item">
              <span className="contact-icon">📞</span>
              <div>
                <h4>Phone Support</h4>
                <p>+1 (555) 123-4567</p>
              </div>
            </div>
            <div className="contact-item">
              <span className="contact-icon">🌐</span>
              <div>
                <h4>Website</h4>
                <p>www.aesoppricing.com</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage; 